import { render, staticRenderFns } from "./Idea.vue?vue&type=template&id=1f985cf5&scoped=true&"
import script from "./Idea.vue?vue&type=script&lang=ts&"
export * from "./Idea.vue?vue&type=script&lang=ts&"
import style0 from "./Idea.vue?vue&type=style&index=0&id=1f985cf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f985cf5",
  null
  
)

export default component.exports